import { render } from "./ThirdAppManagement.vue?vue&type=template&id=21a22242&scoped=true"
import script from "./ThirdAppManagement.vue?vue&type=script&lang=js"
export * from "./ThirdAppManagement.vue?vue&type=script&lang=js"

import "./ThirdAppManagement.vue?vue&type=style&index=0&id=21a22242&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a22242"]])

export default __exports__